(function () {
    document.addEventListener("DOMContentLoaded", function () {
        // ===== Drawer behavior (mobile filters) =====
        const openBtn = document.getElementById('openFilters');
        const closeBtn = document.getElementById('closeFilters');
        const drawer = document.getElementById('drawer');
        const backdrop = document.getElementById('drawerBackdrop');

        const openDrawer = () => {
            if (!drawer) return;
            drawer.setAttribute('aria-hidden', 'false');
            document.body.style.overflow = 'hidden';
            closeBtn && closeBtn.focus();
        };
        const closeDrawer = () => {
            if (!drawer) return;
            drawer.setAttribute('aria-hidden', 'true');
            document.body.style.overflow = '';
            openBtn && openBtn.focus();
        };

        openBtn && openBtn.addEventListener('click', openDrawer);
        closeBtn && closeBtn.addEventListener('click', closeDrawer);
        backdrop && backdrop.addEventListener('click', closeDrawer);
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && drawer && drawer.getAttribute('aria-hidden') === 'false') closeDrawer();
        });


        // ===== Sort Dropdown Logic =====
        const sortSelect = document.getElementById('sort');
        if (sortSelect) {
            sortSelect.addEventListener('change', function (e) {
                const url = new URL(window.location.href);
                url.searchParams.set('sort_by', e.target.value);
                window.location.href = url.href;
            });
        }


        // ===== Native Faceted Filtering AJAX Form Submissions =====
        // Instead of writing a full SPA AJAX integration for filters from scratch here,
        // we'll listen to the form change and submit the standard URL for simplicity 
        // to mimic default Shopify behavior elegantly initially.
        const filterForms = document.querySelectorAll('form#FacetFiltersForm, form#FacetFiltersFormMobile');

        filterForms.forEach(form => {
            form.addEventListener('change', function () {
                // If it's a typing input (like a price range), we might delay or require 'blur'
                // For checkboxes, submit immediately
                form.submit();
            });
        });

        // ===== Add to cart AJAX =====
        const toast = document.getElementById('toast');
        let toastTimer = null;

        const showToast = (msg) => {
            if (!toast) return;
            toast.textContent = msg;
            toast.classList.add('show');
            clearTimeout(toastTimer);
            toastTimer = setTimeout(() => toast.classList.remove('show'), 3000);
        };

        const addToCartForms = document.querySelectorAll('.custom-add-to-cart-form');
        addToCartForms.forEach(form => {
            form.addEventListener('submit', function (e) {
                e.preventDefault();

                const btn = form.querySelector('.add-btn');
                const productName = btn.getAttribute('data-add') || 'Item';
                const originalText = btn.innerHTML;

                // Set loading state
                btn.classList.add('loading');
                btn.innerHTML = `<svg class="animate-spin h-4 w-4 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg> Adding...`;

                const formData = new FormData(form);

                fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    body: formData
                })
                    .then(response => {
                        return response.json();
                    })
                    .then(item => {
                        // Success
                        showToast(`Added: ${productName}`);

                        // Trigger theme cart drawer if Ella supports global events
                        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                            detail: {
                                product: item
                            }
                        }));
                    })
                    .catch(error => {
                        showToast('Error adding to cart');
                        console.error('Error:', error);
                    })
                    .finally(() => {
                        // Reset Button
                        btn.classList.remove('loading');
                        btn.innerHTML = originalText;
                    });
            });
        });
    });
})();
